import * as ALERT_DASHBOARD from "../files/planning/alertDashboard.i18n";
import * as AVAILABILIIES from "../files/planning/availabilities.i18n";
import * as DIVISION from "../files/planning/division.i18n";
import * as FLUX from "../files/planning/flux.i18n";
import * as LOGIN from "../files/planning/login.i18n";
import * as NAMED_RESOURCE from "../files/planning/namedResources.i18n";
import * as NAVBAR from "../files/planning/navbar.i18n";
import * as ORGANIZATIONS from "../files/planning/organizations.i18n";
import * as PLANE from "../files/planning/plane.i18n";
import * as PRODUCT_MODEL from "../files/planning/productModel.i18n";
import * as PREFIX from "../files/planning/productPrefix.i18n";
import * as PRODUCT_STATES from "../files/planning/productStates.i18n";
import * as RECURRING_DATA from "../files/planning/recurringData.i18n";
import * as REF_CODE_EVENTS from "../files/planning/refCodeEvents.i18n";
import * as GROUPS from "../files/planning/refGroups.i18n";
import * as INSTRUCTOR_ROLES from "../files/planning/refInstructorRoles.i18n";
import * as REF_RULES_CATEGORIES from "../files/planning/refRulesCategories.i18n";
import * as SEASONS from "../files/planning/refSeasons.i18n";
import * as SERVICE_PROVIDER from "../files/planning/refServiceProvider.i18n";
import * as TIME_CODES from "../files/planning/refTimeCodes.i18n";
import * as TIME_VACATIONS from "../files/planning/refTimeVacations.i18n";
import * as RESOURCE from "../files/planning/resource.i18n";
import * as RESOURCE_SKILLS from "../files/planning/resourceSkill.i18n";
import * as RESOURCES_SITUATIONS from "../files/planning/resourcesSituation.i18n";
import * as RULES from "../files/planning/rules.i18n";
import * as SITES from "../files/planning/sites.i18n";
import * as SKILL_LEVEL from "../files/planning/skillLevel.i18n";
import * as SKILLS from "../files/planning/skills.i18n";
import * as TASKS from "../files/planning/tasks.i18n";
import * as TIMELINE from "../files/planning/timeline.i18n";
import * as TIMETABLES from "../files/planning/timetables.i18n";

import * as TRAINING_COURSE from "../files/planning/trainingCourse.i18n";
import * as TRAINING_PRODUCT_STATES from "../files/planning/trainingProductStates.i18n";
import * as USERS_PROFILES from "../files/planning/usersProfiles.i18n";
import * as USERS_PROFILES_APPLICATION_PAGES_ACCESS from "../files/planning/usersProfilesApplicationPagesAccess.i18n";

import * as REF_RESOURCES_GROUPS from "../files/planning/refResourcesGroups.i18n";


export const navbar = NAVBAR;
export const login = LOGIN;
export const skills = SKILLS;
export const division = DIVISION;
export const tasks = TASKS;
export const plane = PLANE;
export const refResourcesGroups = REF_RESOURCES_GROUPS;
export const resource = RESOURCE;
export const refCodeEvents = REF_CODE_EVENTS;
export const productStates = PRODUCT_STATES;
export const prefix = PREFIX;
export const refTimeCodes = TIME_CODES;
export const sites = SITES;
export const skillLevel = SKILL_LEVEL;
export const timeline = TIMELINE;
export const resourceSkills = RESOURCE_SKILLS;
export const flux = FLUX;
export const productModel = PRODUCT_MODEL;
export const namedResources = NAMED_RESOURCE;
export const organizations = ORGANIZATIONS;
export const refTimeVacations = TIME_VACATIONS;
export const availabilities = AVAILABILIIES;
export const timetables = TIMETABLES;
export const resourcesSituation = RESOURCES_SITUATIONS;
export const trainingCourse = TRAINING_COURSE;
export const refServiceProvider = SERVICE_PROVIDER;
export const refInstructorRoles = INSTRUCTOR_ROLES;
export const trainingProductStates = TRAINING_PRODUCT_STATES;
export const usersProfilesApplicationPagesAccess = USERS_PROFILES_APPLICATION_PAGES_ACCESS;
export const usersProfiles = USERS_PROFILES;
export const rules = RULES;
export const rulesCategories = REF_RULES_CATEGORIES;
export const recurringData = RECURRING_DATA;
export const seasons = SEASONS;
export const groups = GROUPS;
export const alertDashboard = ALERT_DASHBOARD;